module.exports = __webpack_public_path__ + "static/media/mailIcon.54218acf.svg";